
import { NoseurObject } from "@ronuse/noseur";
import { BaseService, SanitizedResponse } from "../BaseService";

export enum IResourceType {
    VIDEO = "VIDEO",
    ARTICLE = "ARTICLE",
    DOCUMENT = "DOCUMENT",
}

export interface ISupportResource {
    type: IResourceType;
    description: string;
    url_location: string;
}

export class SupportResourceService extends BaseService {

    protected static instance: SupportResourceService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!SupportResourceService.instance) SupportResourceService.instance = new SupportResourceService();
        return SupportResourceService.instance;
    }

    querySupportResources(query: NoseurObject<string | number> = { page: 1, size: 1 }): Promise<any> {
        return this.report(this.transport.get("/hera/api/v1/support/resource", { cache: true, query: this.normalizeParams(query) }), ({ sanitized }: SanitizedResponse<any>) => {
            sanitized.video_resources = sanitized.content?.filter((r: ISupportResource) => r.type === IResourceType.VIDEO);
            sanitized.article_resources = sanitized.content?.filter((r: ISupportResource) => r.type === IResourceType.ARTICLE);
            sanitized.document_resources = sanitized.content?.filter((r: ISupportResource) => r.type === IResourceType.DOCUMENT);
        });
    }

}
